import { Fragment} from "react";

import Grid from '@mui/material/Grid2'

import StackCustom from "../../../components/StackCustom";

export default function DashboardBody(props) {

  const {configBradCrumbs, configStack,    
         switchCase, children,
         setSwitchCase, renderMap,} =props



  
  return (
    <Fragment>
    <Grid container size={{xs:12, md:8, lg:12}}>
      <Grid item size={{xs:12, lg:6}}> 
        <configBradCrumbs.Component {...configBradCrumbs.generalConfig} {...configBradCrumbs.config}/>
      </Grid>
      <Grid container size={{xs:12, lg:6}} justifyContent="flex-end" direction={"row"}>
        <StackCustom stackConfig={configStack} setSwitchCase={setSwitchCase} switchCase={switchCase}>
          <div id="modal-portal"/>
         {renderMap && renderMap()}
        </StackCustom> 
      </Grid>
      {children}
    </Grid>
  </Fragment>
  )
}
